import { RecipeVersionOption } from '../recipes/types'

export const EMPTY_PLACEHOLDER = '-'

export interface OptionalProduct {
  id: number
  name: string
}

export interface OrderRecipeVersion extends RecipeVersionOption {
  price: number
  optional_products: OptionalProduct[]
}

export interface OrderRecipeGroup {
  id: number
  name: string
  price: number
  image_url: string
  portion_type: string
  versions: OrderRecipeVersion[]
}

export interface OrderRecipesResponse {
  order_recipes: OrderRecipeGroup[]
  has_more_records_in_scope: boolean
}

export interface OrderProvider {
  provider_type: string
}

export interface SelectOption {
  label: string
  value: string
}

export interface OrderRowVoucher {
  initiator: 'customer' | 'staff' | 'system' | null
  issued_by: string | null
  status: 'active' | 'redeemed' | 'expired' | 'invalidated'
  url: string | null
}

export interface OrderRow {
  record_type: 'queued_order' | 'command'
  id: number
  state: string
  type: 'meal' | 'technical'
  recipe_name: string | null
  planned_start_time: string | null
  planned_end_time: string | null
  original_planned_start_time?: string | null
  original_planned_end_time?: string | null
  start_time?: string | null
  end_time?: string | null
  queue_number: number | null
  created_at: string | null
  created_at_epoch: number
  meal_status?: string
  order_item_id?: number | null
  marked_for_disposal?: boolean
  manual_disposal_requestable?: boolean
  prioritized?: boolean
  asap?: boolean
  with_time_slot?: boolean | null
  locker_openable?: boolean | null
  locker_number?: number | null
  seconds_in_locker?: number | null
  in_locker?: boolean
  measured_meal_weight_display?: string | null
  phone_number?: string | null
  date?: string | null
  voucher?: OrderRowVoucher | null
}

export interface OrderGroup {
  record_type: 'order'
  order_id: number | null
  order_number: string | null
  phone_number: string | null
  external_id: string | null
  created_at_epoch: number
  queued_orders: OrderRow[]
}

export interface OrderGroupsResponse {
  order_groups: OrderGroup[]
  page_count: number | null
}

export interface OrderIssueRow {
  id: number
  issue_type: string
  created_at: string | null
  recent: boolean
  order_failed_reason: string | null
  product_name: string | null
  queued_order_id: number | null
  queued_order_state: string | null
  voucher?: OrderRowVoucher | null
  recipe_name: string | null
  order_id: number | null
  order_number: string | null
  external_id: string | null
  phone_number: string | null
}

export interface OrderIssuesResponse {
  order_issues: OrderIssueRow[]
  page_count: number | null
  can_view_queued_orders: boolean
  can_view_orders: boolean
}

export interface ActionItem {
  key: string
  href: string
  label: string
  danger?: boolean
  method?: 'put' | 'post'
  confirm?: string
}
